/** Map API action types to user-facing labels and default routes */
export const ACTION_META = {
  REVIEW: { label: 'Review', path: '/review', tone: 'review' },
  PRACTICE: { label: 'Practice', path: '/practice', tone: 'practice' },
  LEARN: { label: 'Learn', path: '/library', tone: 'learn' },
  QUIZ: { label: 'Quiz', path: '/practice', tone: 'practice' },
  FLASHCARDS: { label: 'Flashcards', path: '/practice', tone: 'review' },
  CHALLENGE: { label: 'Challenge', path: '/practice', tone: 'practice' },
  INTERVIEW: { label: 'Interview', path: '/interview', tone: 'interview' },
};

export function resolveLearningLink(action) {
  if (!action) return '/hub/today';
  if (action.linkPath) return action.linkPath;
  return ACTION_META[action.type]?.path || '/library';
}

export function actionTypeLabel(type) {
  return ACTION_META[type]?.label || type || 'Learn';
}

/** API topics often arrive as long slugs — show a short human label in UI. */
export function formatLearningTopicLabel(raw) {
  if (raw == null) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';
  const looksSlug =
    trimmed.includes('_') && !/\s/.test(trimmed) && trimmed.length >= 10;
  if (!looksSlug) return trimmed.length > 72 ? `${trimmed.slice(0, 69)}…` : trimmed;
  const words = trimmed
    .replace(/_q$/i, '')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .slice(0, 8)
    .join(' ');
  if (!words) return trimmed.slice(0, 48);
  const titled = words.replace(/\b\w/g, (c) => c.toUpperCase());
  return titled.length > 72 ? `${titled.slice(0, 69)}…` : titled;
}

/** Replace slug-like tokens in API copy with readable topic labels. */
export function formatLearningReason(reason, topicRaw) {
  if (!reason) return '';
  const topicLabel = formatLearningTopicLabel(topicRaw);
  const fallback = topicLabel || 'this topic';
  let text = String(reason);
  text = text.replace(/`([^`]+)`/g, (_, inner) => formatLearningTopicLabel(inner) || fallback);
  text = text.replace(/[a-z][a-z0-9_]{14,}/gi, (match) => {
    if (!match.includes('_')) return match;
    return formatLearningTopicLabel(match) || fallback;
  });
  return text;
}

export function masteryStatusLabel(score) {
  if (score >= 80) return { text: 'Strong signal', className: 'mastery-pill--strong' };
  if (score >= 55) return { text: 'Building', className: 'mastery-pill--moderate' };
  if (score > 0) return { text: 'Needs focus', className: 'mastery-pill--weak' };
  return { text: 'Not assessed', className: 'mastery-pill--muted' };
}

export const SKILL_GAP_BUCKETS = {
  strong: { title: 'Strong match', desc: 'Your mastery signal aligns with this skill.' },
  moderate: { title: 'Moderate', desc: 'Some exposure — more practice will help.' },
  needsWork: { title: 'Needs work', desc: 'Priority area for your plan.' },
  notAssessed: { title: 'Not assessed', desc: 'No matching activity in your profile yet.' },
};

export const TIME_PRESETS = [10, 15, 25, 45];

export const TUTOR_PROMPTS = [
  'Explain the core idea simply',
  'Give me a real-world example',
  'Quiz me with one question',
  'What are common mistakes?',
  'Compare to related concepts',
];
